import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function DesalfandegamentoPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Desalfandegamento'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoDesalfandegamentoAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Desalfandegamento processo em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoDesalfandegamentoChefeArea'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Desalfandegamento processo em Chefe de Área '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoDesalfandegamentoChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Desalfandegamento processo em Chefe de Departamento '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoDesalfandegamentoDirectoraGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Desalfandegamento processo em Directora Geral Adjunta '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoDesalfandegamentoDirectorGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Desalfandegamento  processo em Director Geral '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesDesalfandegamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestao de Reclamações de Desalfandegamento '}
                  descricao={''}
                />
              , editable: false,
            },

          ]} />

    </>
  )
}
